import { useContext } from 'react';

import { PublicEchoWebsocketService } from '../../services/PublicEchoWebsocketService';
import { WebsocketContext } from '../../WebsocketContext';

export const usePublicWebsocketService = (): PublicEchoWebsocketService => {
  const { publicWebsocketService } = useContext(WebsocketContext);

  if (!publicWebsocketService) {
    throw new Error('Public Websocket Service has not been initialized');
  }

  return publicWebsocketService;
};
